import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function SideBar(props) {
  const { children } = props;

  const [showSideBar, setSideBar] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;

    if (path === "/auth/login") {
      setSideBar(true);
    } else if (path === "/auth/registration") {
      setSideBar(true);
    } else if (path === "/auth/forgot-password") {
      setSideBar(true);
    }
  }, []);
  return (
    <>
      {showSideBar && (
        <div className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10">
          <div className="d-flex flex-row-fluid flex-column justify-content-between">
            <Link to="/" className="flex-column-auto mt-5">
              <a
                href="/"
                style="color: rgb(252, 178, 74); font-weight: 700; font-size: 24px;"
              >
                equipbid
              </a>
            </Link>

            <div className="flex-column-fluid d-flex flex-column justify-content-center">
              <h3 className="font-size-h1 mb-5 text-white">
                Welcome to equipbid
              </h3>

              <p className="font-weight-lighter text-white opacity-80">
                Lorem ipsum dolor sit amet consectetur adipiscing elit sed do.
              </p>
            </div>
          </div>
        </div>
      )}
      <div className="flex-row-fluid d-flex flex-column position-relative pl-7 pr-7 overflow-hidden">
        <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
          {children}
        </div>
      </div>
    </>
  );
}
